import {
    Card,
    Group,
    TextInput,
    Stack,
    Text,
    NumberInput,
  } from '@mantine/core';
  import { type UseFormReturnType } from '@mantine/form';
  import { type CreateClient } from '@/schemas/API/POST/client/request';
  
  interface Address {
    street: string;
    city: string;
    postCode: string;
    descNum: number;
    orientNum: number;
  }
  
  interface AddressCardProps {
    addressType: string;
    field: 'permAddress' | 'servAddress';
    disabled?: boolean;
    formContext: () => UseFormReturnType<CreateClient>;
  }
  
  export const AddressCard: React.FC<AddressCardProps> = (props) => {
    const form = props.formContext();
    const addr = props.field;
  
    const address = form.values[addr] as Address;
  
    return (
      <Card shadow="sm" padding="md" radius="md" withBorder>
        <Text fw={700} size="large">
          {props.addressType}
        </Text>
        <Stack gap="sm" className="mt-3">
          <TextInput
            variant="filled"
            label="Ulice"
            radius="md"
            disabled={props.disabled}
            {...form.getInputProps(`${addr}.street`)}
          />
  
          <Group justify="space-between" grow className="flex items-start">
            <NumberInput
              variant="filled"
              label="Č.p."
              radius="md"
              hideControls
              value={address.descNum !== 0 ? address.descNum : ''}
              onChange={(value) => {
                form.setFieldValue(`${addr}.descNum`, Number(value) || 0);
              }}
              min={0}
              error={form.getInputProps(`${addr}.descNum`).error}
              allowDecimal={false}
              disabled={props.disabled}
            />
            <NumberInput
              variant="filled"
              label="Č.o."
              radius="md"
              hideControls
              value={address.orientNum !== 0 ? address.orientNum : ''}
              onChange={(value) => {
                form.setFieldValue(`${addr}.orientNum`, Number(value) || 0);
              }}
              min={0}
              error={form.getInputProps(`${addr}.orientNum`).error}
              allowDecimal={false}
              disabled={props.disabled}
            />
          </Group>

          <TextInput
            variant="filled"
            label="Město"
            radius="md"
            {...form.getInputProps(`${addr}.city`)}
            disabled={props.disabled}
          />

          <NumberInput
            variant="filled"
            label="PSČ"
            radius="md"
            hideControls
            value={address.postCode !== '' ? Number(address.postCode) : ''}
            onChange={(value) => {
              form.setFieldValue(`${addr}.postCode`, String(value));
            }}
            min={0}
            error={form.getInputProps(`${addr}.postCode`).error}
            allowDecimal={false}
            disabled={props.disabled}
          />
        </Stack>
      </Card>
    );
  };
  